import React from 'react';
import { FileText, CheckSquare, PenTool, Download } from 'lucide-react';
import { Card } from './ui/Card';
export function BonusesSection() {
  const bonuses = [{
    icon: FileText,
    title: 'Contrato Familiar Digital',
    desc: 'Plantilla lista para imprimir donde todos (incluidos papá y mamá) firman compromisos.'
  }, {
    icon: CheckSquare,
    title: 'Checklists Diarios',
    desc: 'Para que no tengas que recordar qué toca hoy. Simplemente sigue la lista.'
  }, {
    icon: PenTool,
    title: 'Plan Reset',
    desc: 'Guía paso a paso para reiniciar los dispositivos y configurarlos a prueba de niños.'
  }, {
    icon: Download,
    title: 'Registro de Progresos',
    desc: 'Mide objetivamente la reducción de berrinches y horas de pantalla.'
  }];
  return <section className="py-20 bg-brand-light border-y border-slate-200" data-id="element-1">
      <div className="container mx-auto px-4" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <span className="text-brand-secondary font-bold tracking-wider uppercase text-sm" data-id="element-4">
            Incluido Gratis
          </span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-slate-900 mt-2" data-id="element-5">
            Herramientas Imprimibles
          </h2>
          <p className="text-slate-600 mt-4 max-w-2xl mx-auto" data-id="element-6">
            No solo teoría. Te damos las herramientas físicas para pegar en la
            nevera y usar cada día.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-7">
          {bonuses.map((bonus, i) => <Card key={i} className="p-6 text-center hover:border-brand-primary transition-colors duration-300" data-id="element-8">
              <div className="w-12 h-12 bg-white border border-slate-200 rounded-xl flex items-center justify-center mx-auto mb-4 shadow-sm text-brand-primary" data-id="element-9">
                <bonus.icon className="w-6 h-6" data-id="element-10" />
              </div>
              <h3 className="font-bold text-slate-900 mb-2" data-id="element-11">{bonus.title}</h3>
              <p className="text-sm text-slate-600" data-id="element-12">{bonus.desc}</p>
            </Card>)}
        </div>
      </div>
    </section>;
}